import { render, staticRenderFns } from "./TabStageNavigation.vue?vue&type=template&id=b1737b18&scoped=true"
import script from "./TabStageNavigation.vue?vue&type=script&lang=js"
export * from "./TabStageNavigation.vue?vue&type=script&lang=js"
import style0 from "./TabStageNavigation.vue?vue&type=style&index=0&id=b1737b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1737b18",
  null
  
)

export default component.exports